
import { ChangeEvent, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, IconButton, InputBase, InputLabel, MenuItem, Paper, Select, Snackbar, TextField, Typography } from '@mui/material';

import { Eventcalendar, MbscCalendarEvent, MbscEventcalendarView, setOptions, localeEs, CalendarNav, CalendarNext, CalendarPrev, CalendarToday, Segmented, SegmentedGroup, Popup, MbscEventClickEvent, formatDate, MbscCalendarInvalid, MbscCalendarEventData } from '@mobiscroll/react';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from '@mui/icons-material/Clear';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import '@mobiscroll/react/dist/css/mobiscroll.min.css';

import 'moment/locale/es';
import moment, { Moment } from 'moment';

import { DialogSolicitudes } from '../../dialogs/DialogSolicitudes';

import { ObtenerJueces, ObtenerSecretarios } from '../../connections/admin/UsuarioConnection';
import { BuscarExpediente } from '../../connections/comun/ExpedienteConnection';
import { ObtenerTipoAudienciaMateria } from '../../connections/catalogos/TipoAudienciaConnection';
import { CancelarAgenda, GuardarAgenda, LiberarAudiencia, ObtenerAgenda, ObtenerSolicitudes } from '../../connections/comun/AgendaConnection';

import { AlertProps } from '../../interfaces/global/AlertInterface';

import { JuezProps } from '../../interfaces/catalogos/JuezInterface';
import { SecretarioProps } from '../../interfaces/catalogos/SecretarioInterface';
import { TipoAudienciaProps } from '../../interfaces/catalogos/TipoAudienciaInterface';
import { ExpedienteProps } from '../../interfaces/comun/ExpedienteInterface';

import { SolicitudProps } from '../../interfaces/comun/SolicitudInterface';
import { AudienciaProps, CancelarEventoParams, GuardarAgendaProps } from '../../interfaces/comun/AgendaInterface';

import '../../css/Calendar.css';
import { GetContrastTextColor } from '../../helpers/GetContrastTextColor';

setOptions({
    locale: localeEs,
    theme: 'ios',
    themeVariant: 'light',
});

const now = new Date();

const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);

type ActionType = 'Nuevo' | 'Editar'| '';

interface TaskProps {
    solicitud: SolicitudProps;
    handleOpen: () => void;
}

interface Error {
    descripcion?:  string;
}

function Task({ solicitud, handleOpen }: TaskProps) {

    const { tipoAudiencia, numeroExpediente, juez, solicitante } = solicitud;

    return (
        <div>
            {
                <div className="external-drop-task" style={{ background: '#ccc' }}>

                    <Typography textAlign={'center'} variant='h6' color='black'>{tipoAudiencia}</Typography>

                    <Typography variant='body2' color='black' fontWeight={'bold'} mt={1}>Juez:</Typography>                        
                    <Typography variant='body2' color='black'>{juez}</Typography> 
            
                    <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Número expediente:</Typography> 
                    <Typography variant='body2' color='black'>{numeroExpediente}</Typography> 

                    {
                        solicitante
                        &&
                            <>
                                <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Solicitante:</Typography>                      
                                <Typography variant='body2' color='black' fontSize={12}>{solicitante}</Typography>               
                            </>
                    }                

                    <Button fullWidth variant='contained' color='primary' sx={{ mt: 2 }} onClick={handleOpen}>
                        Agendar
                    </Button>
                </div>
            }
        </div>
    );
}

const isWeekend = (date: Moment) => {
    const day = date.day();

    return day === 0 || day === 6;
};

const defaultSelectedAudiencia: AudienciaProps = { idAgenda: 0, duracion: 0, idEstatus: 0, idJuez: 0, juez : '', idSecretario: 0, secretario: '', numeroExpediente : '', solicitante: '', tipoAudiencia: '' };
const defaultExpediente: ExpedienteProps = { idExpediente: 0, numeroExpediente: '', idJuez: 0, juez: '' };

export const CalendarPage = () => {

    const [audienciaSelected, setAudienciaSelected] = useState<AudienciaProps>( defaultSelectedAudiencia );
    const [audienciaSelectedTime, setAudienciaSelectedTime] = useState('');
   
    const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);
    const [tooltipAnchor, setTooltipAnchor] = useState();
    const [action, setAction] = useState<ActionType>('Nuevo');

    const [openCancelacion, setOpenCancelacion] = useState<boolean>(false);
    const [openEvento, setOpenEvento] = useState<boolean>(false);
    const [openSolicitudes, setOpenSolicitudes] = useState(false);

    const [openConfirmacionLiberar, setOpenConfirmacionLiberar] = useState<boolean>(false);

    const [view, setView] = useState('week');

    const [error, setError] = useState<Error>({});

    const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

    const [audiencias, setAudiencias] = useState<AudienciaProps[]>([]);
    const [audienciasFiltered, setAudienciasFiltered] = useState<AudienciaProps[]>([]);

    const [solicitudes, setSolicitudes] = useState<SolicitudProps[]>([]);
    const [solicitudesFiltered, setSolicitudesFiltered] = useState<SolicitudProps[]>([]);

    const [juez, setJuez] = useState(0);
    const [juecesArray, setJuecesArray] = useState<JuezProps[]>([]);

    const [secretario, setSecretario] = useState(0);
    const [secretariosArray, setSecretariosArray] = useState<SecretarioProps[]>([]);

    const [tipoAudiencia, setTipoAudiencia] = useState<number>(0);
    const [tipoAudienciaArray, setTipoAudienciaArray] = useState<TipoAudienciaProps[]>([]);

    const [motivoCancelacion, setMotivoCancelacion] = useState<string>("");
    const [numeroExpediente, setNumeroExpediente] = useState<string>("");

    const [loadingButton, setLoadingButton] = useState<boolean>(false);
    const [loadingData, setLoadingData] = useState(true);
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [loadingLiberar, setLoadingLiberar] = useState(false);
    const [isFiltered, setIsFiltered] = useState<boolean>(false);

    const [duracion, setDuracion] = useState(0);
    const [fecha, setFecha] = useState<Moment>(moment(tomorrow));
    const [horaInicio, setHoraInicio] = useState<Date>(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 8));
    const [horaFin, setHoraFin] = useState<Date>(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 9));

    const [alert, setAlert] = useState<AlertProps>({ open: false, msg: "", type: "warning" });

    const [loadingExpediente, setLoadingExpediente] = useState<boolean>(false);
    const [expediente, setExpediente] = useState<ExpedienteProps>( defaultExpediente );

    const handleOpen = ({ idAgenda, tipoAudiencia, idJuez, juez, solicitante, numeroExpediente, duracion }: SolicitudProps ) => {

        setAudienciaSelected({
            id: idAgenda,
            idAgenda: idAgenda, 
            tipoAudiencia: tipoAudiencia,
            numeroExpediente,
            solicitante,
            duracion: duracion,
            idJuez, 
            juez,
            idEstatus: 5, 
            idSecretario: 0,
            secretario: '',
            title: tipoAudiencia,
            start: new Date(),
            end: new Date(),
        });

        setHoraFin( new Date( now.getFullYear(), now.getMonth(), now.getDate(), 8, duracion ?? 0 ) );

        setAction('Editar');
        setOpenEvento(true);
    }

    const myInvalid: MbscCalendarInvalid[] = useMemo(() => [
        {
            recurring: {
                repeat: 'daily',
                until: yesterday,
            },
            cssClass: 'md-lunch-break-class mbsc-flex',
        },
    ], [],
    );

    const [calView, setCalView] = useState<MbscEventcalendarView>({
        schedule: {
            type: 'week',
            startTime: '08:00',
            endTime: '16:00',
            allDay: false,
            startDay: 1,
            endDay: 5,
            timeCellStep: 30,
            timeLabelStep: 30,
            currentTimeIndicator: false,
        },
    });

    const changeView = useCallback((event: ChangeEvent<HTMLInputElement>) => {

        let calView = {};

        switch (event.target.value) {
            case 'week':
                calView = {
                    schedule: {
                        type: 'week',
                        startTime: '08:00',
                        endTime: '16:00',
                        allDay: false,
                        startDay: 1,
                        endDay: 5,
                        timeCellStep: 30,
                        timeLabelStep: 30,
                        currentTimeIndicator: false,
                    },
                };
                break;
            case 'day':
                calView = {
                    schedule: {
                        type: 'day',
                        startTime: '08:00',
                        endTime: '16:00',
                        allDay: false,
                        startDay: 1,
                        endDay: 5,
                        timeCellStep: 30,
                        timeLabelStep: 30,
                        currentTimeIndicator: false,
                    },
                };
                break;
        }

        setView(event.target.value);
        setCalView(calView);

    }, []);

    const customWithNavButtons = useCallback(
        () => (
            <>
                <CalendarNav className="cal-header-nav" />

                <div className="cal-header-picker">
                    <SegmentedGroup value={view} onChange={changeView}>
                        <Segmented value="week">Semana</Segmented>
                        <Segmented value="day">Dia</Segmented>
                    </SegmentedGroup>
                </div>

                <CalendarPrev className="cal-header-prev" />
                <CalendarToday className="cal-header-today" />
                <CalendarNext className="cal-header-next" />
            </>
        ),
        [changeView, view],
    );

    const openTooltip = useCallback((args: MbscEventClickEvent) => {

        const event: MbscCalendarEvent = args.event;
        const time = formatDate('hh:mm A', new Date(event.start! as string)) + ' - ' + formatDate('hh:mm A', new Date(event.end! as string));

        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = undefined;
        }

        var audiencia = audiencias.find((e) => e.id === event.id);

        if( audiencia ){
            
            setAudienciaSelected( audiencia );
            
            setAudienciaSelectedTime( time );
            setTooltipAnchor(args.domEvent.target.closest('.mbsc-schedule-event'));
    
            setTooltipOpen(true);
        }

    }, [audiencias]);

    const handleEventClick = useCallback(
        (args: MbscEventClickEvent) => {
            openTooltip(args);
        },
        [openTooltip],
    );

    const handleEventDragStart = useCallback(() => {
        setTooltipOpen(false);
    }, []);

    const customScheduleEvent = useCallback( ( data: MbscCalendarEventData ) => {
    
        if ( data.allDay ) {

            return (
                <div style={{ background: data.color }} className="md-custom-event-allday-title">
                    {data.title}
                </div>
            );
        } 
        else {

            const estatus = audiencias.find( (e) => e.id === data.id )?.idEstatus;

            return (
                <div className="md-custom-event-cont" style={{ borderLeft: '5px solid ' + data.color, background: data.color }}>
            
                    <div className="md-custom-event-wrapper">

                        <Grid container px={1} pt={1}>

                            <Grid size={10}>
                                <Typography variant='body1' sx={{ color: GetContrastTextColor( data.color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} fontSize={12}> { data.title } </Typography>                               
                            </Grid>

                            {
                                estatus === 7
                                &&
                                    <Grid size={2}>
                                        <DoneAllIcon fontSize='small' sx={{ color: GetContrastTextColor( data.color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} />     
                                    </Grid>
                            }

                            <Grid size={12}>
                                <Typography variant='body1' sx={{ color: GetContrastTextColor( data.color ?? 'rgb(0, 0, 0)' ) === 'white' ? '#fff': '#000' }} fontSize={10}> { data.start?.toString() } - { data.end?.toString() } </Typography>  
                            </Grid>

                        </Grid>   
                            
                    </div>

                </div>
            );
        }
    }, [ audiencias ]);

    const handleClose = () => {

        setOpenEvento( false );
        setNumeroExpediente( '' );
        setTipoAudiencia( 0 );
        setSecretario( 0 );
        setAudienciaSelected( defaultSelectedAudiencia );
        setExpediente( defaultExpediente );
        setAction( '' );

        setFecha( moment( tomorrow ) )
        setHoraFin( new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 9) );
        setHoraInicio( new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 8) );
    }

    const handleCloseAlert = (event: any, reason: any) => {

        if (reason === 'clickaway') {
            return;
        }

        setAlert({ open: false, type: "warning" });
    }

    const handleBuscarExpediente = async () => {

        setLoadingExpediente( true );
        setError({});

        await BuscarExpediente({ numeroExpediente }).then(resp => {

            const { success, message, idExpediente, numeroExpediente, idJuez, juez } = resp;

            if( success ){

                setTimeout(() => {

                    setExpediente({ idExpediente, numeroExpediente, idJuez, juez });
                    setNumeroExpediente( '' );
                    
                    setLoadingExpediente( false );

                }, 700);
                
            }
            else {

                setTimeout(() => {

                    setNumeroExpediente( '' );
                    setExpediente( defaultExpediente )
                    
                    setError( { descripcion: message } );
                    setLoadingExpediente( false );

                }, 700);
                
            }            

        });

    }

    const handleGuardar = async ( estatus: number ) => {

        if( estatus === 6 ){
            setLoadingLiberar(true);
        }
        else {
            setLoadingGuardar(true);
        }

        let Validate = true;
        let MessageValidate = '';

        if (fecha.day() === 0 || fecha.day() === 6) {

            setAlert({ open: true, msg: "La fecha no debe de ser en fin de semana", type: "warning" });
            setLoadingGuardar(false);
            return;
        }

        audiencias?.filter(f => moment(f.start).dayOfYear() === fecha.dayOfYear() && f.idEstatus !== 4).forEach(e => {

            const start = moment(e.start).hours() * 60 + moment(e.start).minutes()
            const end = moment(e.end).hours() * 60 + moment(e.end).minutes()

            let itStart = (horaInicio.getHours() * 60 + horaInicio.getMinutes())
            let itEnds = (horaFin.getHours() * 60 + horaFin.getMinutes())

            if (itStart >= start && itStart < end && e.idJuez === audienciaSelected?.idJuez && fecha.dayOfYear() === moment(e.start).dayOfYear() && e.id !== audienciaSelected?.id) {
                Validate = false;
                MessageValidate = 'el Juez(a) ' + e.juez;
            }
            else if (itStart < start && itEnds > start && e.idJuez === audienciaSelected?.idJuez && fecha.dayOfYear() === moment(e.start).dayOfYear() && e.id !== audienciaSelected?.id) {
                Validate = false;
                MessageValidate = 'el Juez(a) ' + e.juez;
            }
            else if (itStart >= start && itStart < end && e.idSecretario === secretario && fecha.dayOfYear() === moment(e.start).dayOfYear() && e.id !== audienciaSelected?.id) {
                Validate = false;
                MessageValidate = 'el secretario(a) ' + e.secretario;
            }
            else if (itStart < start && itEnds > start && e.idSecretario === secretario && fecha.dayOfYear() === moment(e.start).dayOfYear() && e.id !== audienciaSelected?.id) {
                Validate = false;
                MessageValidate = 'el secretario(a) ' + e.secretario;
            }
        })

        if ( !Validate ) {

            setAlert({ open: true, msg: "La hora señalada y dia esta ocupada para " + MessageValidate, type: "warning" });
            setLoadingGuardar(false);
            setLoadingLiberar(false);
            return;
        }

        const params: GuardarAgendaProps = {
            horaFin: moment( horaFin ).format( 'DD-MM-YYYY HH:mm' ),
            horaInicio: moment( horaInicio ).format( 'DD-MM-YYYY HH:mm' ),
            fecha: fecha.format( 'DD-MM-YYYY HH:mm' ),
            idExpediente: action === 'Nuevo' ? expediente.idExpediente : audienciaSelected?.idExpediente,
            idJuez: action === 'Nuevo' ? expediente.idJuez : audienciaSelected?.idJuez,
            idAgenda: audienciaSelected?.id ? parseInt(audienciaSelected.id.toString()) : 0,
            idTipoAudiencia: tipoAudiencia,
            idEstatus: estatus,
            idSecretario:  secretario,
        }

        await GuardarAgenda(params).then( resp => {

            if (resp.success) {

                setTimeout(() => {

                    const audienciaResp: AudienciaProps = {
                        id: resp.idAgenda,
                        idAgenda: resp.idAgenda, 
                        tipoAudiencia: resp.tipoAudiencia,
                        numeroExpediente: resp.numeroExpediente,
                        solicitante: resp.solicitante,
                        duracion: resp.duracion,
                        idJuez: resp.idJuez, 
                        juez: resp.juez,
                        idSecretario: resp.idSecretario,
                        secretario: resp.secretario,
                        idEstatus: estatus, 
                        color: estatus === 6 ? '#1b5e20' : '#4D4D50',    
                        title: resp.tipoAudiencia,
                        start: moment( resp.fechaInicio ?? '' ),
                        end: moment( resp.fechaFin ?? '' ),
                    };

                    if ( action === "Nuevo" ) {                        

                        setAudiencias([ ...audiencias, audienciaResp ]);

                        if ( isFiltered && juez === resp.idJuez ) {
                            setAudienciasFiltered([...audienciasFiltered.filter( id => id.id !== audienciaSelected?.id ), audienciaResp ]);
                        }
                    }
                    else if (action === "Editar") {

                        setSolicitudes( solicitudes.filter( id => id.idAgenda !== audienciaSelected?.id ) );

                        setAudiencias([...audiencias.filter( id => id.id !== audienciaSelected?.id ), audienciaResp ]);

                        if (isFiltered && juez === resp.idJuez) {
                            setAudienciasFiltered([...audienciasFiltered.filter(id => id.id !== audienciaSelected?.id), audienciaResp ]);
                        }

                    }

                    setAlert({ open: true, msg: resp.message, type: "success" });

                    handleClose();

                    if( estatus === 6 ){
                        setLoadingLiberar(false);
                    }
                    else {
                        setLoadingGuardar(false);
                    }

                }, 700);

            }
            else {

                setAlert({ open: true, msg: resp.message, type: "error" });

                if( estatus === 6 ){
                    setLoadingLiberar(false);
                }
                else {
                    setLoadingGuardar(false);
                }

            }

        });

    }

    const handleChangeJuez = ( value: number ) => {

        if( value !== 0 ){
            setIsFiltered( true );
            setAudienciasFiltered( audiencias.filter(id => id.idJuez === value ));
            setSolicitudesFiltered( solicitudes.filter(id => id.idJuez === value ));
        }
        else {
            setIsFiltered( false );
            setAudienciasFiltered( audiencias );
            setSolicitudesFiltered( solicitudes );
        }
        
        setJuez( value );
    }

    const handleChangeTipoAudiencia = ( value: number ) => {

        const tipoAudienciaDuracion = tipoAudienciaArray.find( ( elem ) => elem.idTipoAudiencia === value )?.duracion ?? 0;

        if( tipoAudienciaDuracion !== 0 ){
            setHoraFin( new Date( now.getFullYear(), now.getMonth(), now.getDate(), 8, tipoAudienciaDuracion ?? 0 ) );
        }

        setDuracion( tipoAudienciaDuracion );
        setTipoAudiencia( value );
    }

    const handleCancelarAudiencia = async () => {

        setLoadingButton(true)

        if ( motivoCancelacion === "" ) {

            setAlert({ open: true, msg: "se debe escribir el motivo de cancelar", type: "warning" })
            setLoadingButton(false)
            return
        }

        const params: CancelarEventoParams = {
            motivoCancelacion,
            idAgenda: audienciaSelected?.id ? parseInt(audienciaSelected.id.toString()) : 0,
        }

        await CancelarAgenda(params).then(resp => {

            if ( resp.success ) {

                setTimeout(() => {

                    const newArray = audiencias.map(elem => {    
                        if ( elem.id === audienciaSelected?.id ) {
                            elem.idEstatus = 4;
                            elem.color = 'rgb(188, 64, 101)';
                        }
                        return elem;
                    });

                    setAudiencias( newArray );

                    setAlert({ open: true, msg: "Se cancelo el evento correctamente", type: "success" });                   

                    setMotivoCancelacion( '' );

                    setOpenCancelacion( false );

                    setLoadingButton( false );
                    
                    handleClose();

                }, 700);
            }
            else {
                setLoadingButton( false );
            }

        });
    }

    const handleLiberarAudiencia = async () => {

        setLoadingLiberar( true );     
        
        await LiberarAudiencia({ idAgenda: audienciaSelected.idAgenda ?? 0 }).then(resp => {

            if ( resp.success ) {

                setTimeout(() => {

                    const newArray = audiencias.map(elem => {    
                        if ( elem.id === audienciaSelected?.id ) {
                            elem.idEstatus = 6;
                            elem.color = 'rgb(27, 94, 32)';
                        }
                        return elem;
                    });

                    setAudiencias( newArray );

                    setOpenConfirmacionLiberar( false );
                    setLoadingLiberar( false );

                    setAlert({ open: true, msg: resp.message, type: "success" });

                }, 700);

            }
            else {

                setTimeout(() => {

                    setLoadingLiberar( false );
                    setAlert({ open: true, msg: resp.message, type: "error" });
                    
                }, 700);

            }
        });        
                
    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoAudienciaMateria().then(resp => {

                setTimeout(() => {

                    setTipoAudienciaArray(resp);

                }, 700);

            });

        }

        Obtener()

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerJueces().then(resp => {

                setTimeout(() => {

                    setJuecesArray(resp);

                }, 700);

            });

        }

        Obtener()

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerSecretarios().then(resp => {

                setTimeout(() => {

                    setSecretariosArray(resp);

                }, 700);

            });

        }

        Obtener()

    }, [])

    useEffect(() => {

        async function Obtener() {

            setLoadingData(true);

            await ObtenerSolicitudes().then(resp => {

                setTimeout(() => {

                    setSolicitudes( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        Obtener()

    }, [])

    useEffect(() => {

        async function Obtener() {

            setAudiencias([])

            await ObtenerAgenda().then(resp => {

                console.log( resp );

                setTimeout(() => {                 

                    const newArray = resp.map( ( elem )=> {

                        elem.id = elem.idAgenda;
                        elem.title = elem.tipoAudiencia;
                        elem.start = moment( elem.fechaInicio ?? '' );
                        elem.end =  moment( elem.fechaFin ?? '' );

                        if( elem.idEstatus === 6 ){ elem.color = 'rgb(27, 94, 32)'; }
                        else if( elem.idEstatus === 4 ){ elem.color = 'rgb(188, 64, 101)'; }
                        else if( elem.idEstatus === 7 ){ elem.color = 'rgb(228, 219, 86)'; }
                        else { elem.color = 'rgb(77, 77, 80)'; }                        

                        return elem;
                    });

                    setAudiencias( newArray );

                }, 700);

            });

        }

        Obtener()

    }, [])

    return (
        <div className="mbsc-grid mbsc-no-padding">

            {
                alert.msg
                &&
                    <Snackbar open={alert.open} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} autoHideDuration={2500} onClose={ handleCloseAlert }>
                        <Alert onClose={ () => setAlert({ open: false, type: "warning" }) } variant="filled" severity={alert.type} sx={{ width: '100%' }}>
                            {alert.msg}
                        </Alert>
                    </Snackbar>
            }

            <Grid container spacing={3} mt={3}>

                <Grid size={12}>

                    <Grid container spacing={3}>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl fullWidth>

                                <TextField
                                    select
                                    label="Juez"
                                    slotProps={{
                                        inputLabel: {
                                            shrink: true,
                                        },
                                    }}
                                    value={juez}
                                    onChange={ (e) => handleChangeJuez( parseInt( e.target.value ?? '0' )) }
                                >
                                    <MenuItem value={0}>Seleccione una opción</MenuItem>
                                    {
                                        juecesArray.map((e) => (
                                            <MenuItem key={e.idJuez} value={e.idJuez}>{e.nombre}</MenuItem>
                                        ))
                                    }
                                </TextField>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>

                            <Button fullWidth color='secondary' variant="outlined" sx={{ mt: 1 }} onClick={() => setOpenSolicitudes(true)} >
                                Solicitudes para fecha de audiencia
                            </Button>

                        </Grid>

                        <Grid size={{ xs: 12, md: 2 }}>

                            <Button
                                fullWidth
                                variant="contained"
                                sx={{ mt: 1 }}
                                onClick={() => { setAction('Nuevo'); setAudienciaSelected( defaultSelectedAudiencia ); setOpenEvento(true); }}
                            >
                                Agregar audiencia
                            </Button>

                        </Grid>

                    </Grid>

                </Grid>

                <Grid size={12} mt={1}>

                    <div className="mbsc-row">

                        <div className="mbsc-col-sm-9 external-drop-calendar">

                            <Eventcalendar
                                cssClass="md-switching-view-cont"
                                height={'95vh'}
                                data={ isFiltered ? audienciasFiltered : audiencias }
                                view={calView}
                                invalid={myInvalid}
                                clickToCreate={false}
                                dragToResize={false}
                                eventDelete={false}
                                dragToMove={false}
                                dragToCreate={false}
                                showEventTooltip={false}
                                renderScheduleEvent={ customScheduleEvent }
                                onEventClick={handleEventClick}
                                renderHeader={customWithNavButtons}
                                onEventDragStart={handleEventDragStart}
                            />

                            <Popup
                                anchor={tooltipAnchor}
                                contentPadding={false}
                                display="anchored"
                                isOpen={isTooltipOpen}
                                scrollLock={false}
                                showOverlay={false}
                                touchUi={false}
                                width={350}
                            >
                                <div className="mds-tooltip">

                                    <div className="mds-tooltip-header" style={{ backgroundColor: audienciaSelected.color ?? 'rgb(77, 77, 80)', color: GetContrastTextColor( audienciaSelected.color ?? 'rgb(77, 77, 80)' ) === 'white' ? '#fff': '#000' }}>

                                        <Typography variant='body2' fontSize={18} textAlign={'center'}>{audienciaSelected?.title}</Typography>
                                        <Typography variant='body2' fontSize={14} sx={{ textAlign: "center", mt: 1 }} >{audienciaSelectedTime}</Typography>

                                        <IconButton  size='small' sx={{ position: 'absolute', top: 10, right: 10, border: '1px solid ' + ( GetContrastTextColor( audienciaSelected.color ?? 'rgb(77, 77, 80)' ) === 'white' ? '#fff': '#222' ) }} onClick={ () => setTooltipOpen( false ) }>
                                            <ClearIcon sx={{ color: GetContrastTextColor( audienciaSelected.color ?? 'rgb(77, 77, 80)' ) === 'white' ? '#fff': '#222', fontSize: 16 }} />
                                        </IconButton>

                                        {
                                            !( moment(audienciaSelected?.start) < moment(tomorrow) || audienciaSelected?.idEstatus === 4 || audienciaSelected?.idEstatus === 6 || audienciaSelected?.idEstatus === 7 )
                                            &&
                                                <IconButton
                                                    size='small'
                                                    sx={{ position: 'absolute', top: 45, right: 10, border: '1px solid ' + ( GetContrastTextColor( audienciaSelected.color ?? 'rgb(77, 77, 80)' ) === 'white' ? '#fff': '#222' ) }}
                                                    onClick={() => {
                                                        setAction( 'Editar' );
                                                        setTooltipOpen( false );
                                                        setFecha( moment( audienciaSelected?.start ) );
                                                        setHoraInicio( moment( audienciaSelected?.start ).toDate() );
                                                        setHoraFin( moment( audienciaSelected?.end ).toDate() );
                                                        setSecretario( audienciaSelected.idSecretario );
                                                        setOpenEvento( true );
                                                    }}
                                                >
                                                    <EditIcon sx={{ color: GetContrastTextColor( audienciaSelected.color ?? 'rgb(77, 77, 80)' ) === 'white' ? '#fff': '#222', fontSize: 16 }} />
                                                </IconButton>
                                        }

                                    </div>

                                    <Box sx={{ p: 2, mt: -1 }}>

                                        <Grid container spacing={0}>                                            
                                            <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'} mt={2}>Juez(a):</Typography> </Grid>
                                            <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.juez}</Typography> </Grid>  
                                        </Grid>

                                        <Grid container spacing={0} mt={2}>
                                            <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Secretario(a):</Typography> </Grid>
                                            <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.secretario}</Typography> </Grid>
                                        </Grid>

                                        <Grid container spacing={0} mt={2}>
                                            <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Número expediente:</Typography> </Grid>
                                            <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.numeroExpediente}</Typography> </Grid>
                                        </Grid>

                                        {
                                            audienciaSelected?.solicitante
                                            &&
                                                <Grid container spacing={0} mt={2}>
                                                    <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Solicitante:</Typography> </Grid>
                                                    <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.solicitante}</Typography> </Grid>
                                                </Grid>
                                        }

                                        {
                                            audienciaSelected?.sala
                                            &&
                                                <Grid container spacing={0} mt={2}>
                                                    <Grid size={12}> <Typography variant='body2' color='black' fontWeight={'bold'}>Sala asignada:</Typography> </Grid>
                                                    <Grid size={12}> <Typography variant='body2' color='black'>{audienciaSelected?.sala}</Typography> </Grid>
                                                </Grid>
                                        }
                                        
                                        <Grid container spacing={3}>
                                            {
                                                !( ( moment( audienciaSelected?.start ) < moment( tomorrow ) ) || audienciaSelected?.idEstatus === 4 || audienciaSelected?.idEstatus === 6 || audienciaSelected?.idEstatus === 7 )
                                                &&
                                                    <Grid size={ audienciaSelected?.idEstatus === 5 ? 6 : 12 }>
                                                        <Button startIcon={<ClearIcon />} color="error" variant="contained" fullWidth onClick={ () => { setTooltipOpen( false ); setOpenCancelacion( true ); }} sx={{ mt: 2 }}>
                                                            Cancelar
                                                        </Button>
                                                    </Grid>
                                            }

                                            {
                                                !( ( moment( audienciaSelected?.start ) < moment( tomorrow ) ) || audienciaSelected?.idEstatus === 4 || audienciaSelected?.idEstatus === 6 || audienciaSelected?.idEstatus === 7 )
                                                &&
                                                    <Grid size={6}>
                                                        <Button startIcon={<ClearIcon />} color="success" variant="contained" fullWidth onClick={ () => { setTooltipOpen( false ); setOpenConfirmacionLiberar( true ); }} sx={{ mt: 2 }}>
                                                            Liberar
                                                        </Button>
                                                    </Grid>
                                            }
                                        </Grid>

                                    </Box>

                                </div>

                            </Popup>

                        </div>

                        <div className="mbsc-col-sm-3 external-drop-cont" style={{ padding: 10 }}>

                            <Box textAlign={'center'}>
                                <Typography variant='h5' className="mbsc-form-group-title" my={2}>
                                    Solicitudes
                                </Typography>
                            </Box>

                            <Divider />

                            {
                                !loadingData
                                &&
                                    <Box sx={{ maxHeight: '95vh', overflowY: solicitudes.length === 0 ? 'hidden' : 'scroll' }}>
                                        {
                                            isFiltered
                                            ?
                                                solicitudesFiltered.map( ( solicitud ) => (
                                                    <Task
                                                        key={ solicitud.idAgenda }
                                                        solicitud={ solicitud }
                                                        handleOpen={ () => handleOpen( solicitud ) }
                                                    />
                                                ))
                                            :
                                                solicitudes.map( ( solicitud ) => (
                                                    <Task
                                                        key={ solicitud.idAgenda }
                                                        solicitud={ solicitud }
                                                        handleOpen={ () => handleOpen( solicitud ) }
                                                    />
                                                ))
                                        }

                                        {
                                            ( solicitudes.length === 0 || ( isFiltered && solicitudesFiltered.length === 0 ) )
                                            &&
                                                <Box sx={{ height: '95vh' }} textAlign={'center'}>
                                                    <Typography variant='body2' color='textSecondary' sx={{ mt: 10 }}>
                                                        No se encontraron solicitudes
                                                    </Typography>
                                                </Box>
                                        }
                                    </Box>
                            }

                            {
                                loadingData
                                &&
                                    <Grid size={12} textAlign={'center'} alignContent={'center'} height={700}>
                                        <CircularProgress size={32} />
                                    </Grid>
                            }

                        </div>

                    </div>

                </Grid >

            </Grid >

            <Dialog
                open={openCancelacion}
                onClose={() => { }}
                disableEscapeKeyDown
            >
                <DialogTitle>
                    Cancelar audiencia
                </DialogTitle>

                <DialogContent sx={{ width: 450 }}>

                    <TextField
                        fullWidth
                        multiline
                        label="Motivo de Cancelacion"
                        rows={4}
                        sx={{ mt: 1 }}
                        value={motivoCancelacion}
                        onChange={(e) => setMotivoCancelacion(e.target.value)}
                    />

                </DialogContent>

                <DialogActions>

                    <Button color='secondary'  disabled={loadingButton} onClick={ () => { setOpenCancelacion( false ); setMotivoCancelacion( '' ); }}>
                        Cancelar
                    </Button>

                    <Button loading={loadingButton} variant='contained' onClick={ handleCancelarAudiencia }>
                        Guardar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog
                open={openEvento}
                onClose={() => { }}
                disableEscapeKeyDown
                maxWidth='sm'
            >
                <DialogTitle>
                    Información de la audiencia
                </DialogTitle>

                <DialogContent>

                    <Box sx={{ mt: 1 }}>

                        <Grid container spacing={3}>

                            {
                                action === 'Nuevo'
                                &&
                                    <Grid size={12}>

                                        <Paper
                                            component="form"
                                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
                                        >

                                            <InputBase
                                                sx={{ ml: 1, flex: 1, py: 1 }}
                                                placeholder="Buscar por número de expediente"
                                                inputProps={{ 'aria-label': 'Buscar por número de expediente' }}
                                                value={ numeroExpediente }
                                                onChange={ (e) => setNumeroExpediente( e.target.value ) }                                            
                                            />

                                            <Button
                                                type="button"
                                                variant='contained'
                                                size='small'
                                                sx={{ borderRadius: 10, mr: 1 }}
                                                onClick={ handleBuscarExpediente }
                                                disabled={ numeroExpediente === '' }
                                                loading={ loadingExpediente }
                                            >
                                                <SearchIcon />
                                            </Button>

                                        </Paper>

                                        {
                                            error.descripcion
                                            &&
                                                <Alert variant='standard' color='warning' sx={{ mt: 1 }}>
                                                    { error.descripcion }
                                                </Alert>
                                        }

                                    </Grid>
                            }

                            {
                                audienciaSelected?.idAgenda !== 0
                                &&
                                    <>                                            
                                        <Grid size={7}> 
                                            <Typography variant='body2' color='black' fontWeight={'bold'}>Juez:</Typography>                                                 
                                            <Typography variant='body2' color='black'>{audienciaSelected?.juez}</Typography> 
                                        </Grid>
    
                                        <Grid size={5}> 
                                            <Typography variant='body2' color='black' fontWeight={'bold'}>Número expediente:</Typography>                                            
                                            <Typography variant='body2' color='black'>{audienciaSelected?.numeroExpediente}</Typography> 
                                        </Grid>     

                                        {
                                            audienciaSelected?.solicitante
                                            &&
                                                <Grid size={7}> 
                                                    <Typography variant='body2' color='black' fontWeight={'bold'}>Solicitante:</Typography>                                            
                                                    <Typography variant='body2' color='black'>{audienciaSelected?.solicitante}</Typography> 
                                                </Grid>                                            
                                        }                
                                        
                                        <Grid size={5}> 
                                            <Typography variant='body2' color='black' fontWeight={'bold'}>Tipo de audiencia:</Typography>                                            
                                            <Typography variant='body2' color='black'>{audienciaSelected?.title}</Typography> 
                                        </Grid>                                            
                                    </>
                            }   

                            {
                                ( action === 'Nuevo' && expediente.idExpediente !== 0 )
                                &&
                                    <>                                            
                                        <Grid size={7}> 
                                            <Typography variant='body2' color='black' fontWeight={'bold'}>Juez:</Typography>                                                 
                                            <Typography variant='body2' color='black'>{expediente?.juez}</Typography> 
                                        </Grid>
    
                                        <Grid size={5}> 
                                            <Typography variant='body2' color='black' fontWeight={'bold'}>Número expediente:</Typography>                                            
                                            <Typography variant='body2' color='black'>{expediente.numeroExpediente}</Typography> 
                                        </Grid>                                               
                                    </>
                            }           

                            <Grid size={{ xs: 12, md: 12 }}>

                                <FormControl fullWidth>
                                    <InputLabel shrink>Secretario</InputLabel>
                                    <Select 
                                        label="Secretario"                                    
                                        value={ secretario }                                     
                                        onChange={ (e) => setSecretario(  e.target.value )}

                                    >
                                        <MenuItem value={0}>Seleccione una opción</MenuItem>
                                        {
                                            secretariosArray.map((e) => (
                                                <MenuItem key={e.idSecretario} value={e.idSecretario}>{e.nombre}</MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>

                            </Grid>            

                            {
                                ( action === 'Nuevo' && expediente?.idExpediente !== 0 )
                                &&                                        
                                    <Grid size={12}>

                                        <FormControl fullWidth>
                                            <InputLabel shrink>Tipo de audiencia</InputLabel>
                                            <Select
                                                label="Tipo de audiencia"                                                      
                                                value={ tipoAudiencia }
                                                disabled={ tipoAudienciaArray.length === 0 }
                                                onChange={ (e) => handleChangeTipoAudiencia( e.target.value ) }

                                            >
                                                <MenuItem value={0}>Seleccione una opción</MenuItem>
                                                {
                                                    tipoAudienciaArray.map((e) => (
                                                        <MenuItem key={e.idTipoAudiencia} value={e.idTipoAudiencia}>{e.descripcion}</MenuItem>
                                                    ))
                                                }
                                            </Select>

                                        </FormControl>

                                    </Grid>
                            }                       

                            <Grid size={{ xs: 12, md: 12 }} sx={{ mt: -1 }}>

                                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='es'>
                                    <DateCalendar
                                        disablePast
                                        minDate={moment(tomorrow)}
                                        shouldDisableDate={isWeekend}
                                        value={moment(fecha)}
                                        onChange={(e) => setFecha(moment(e, "dd/MM/yyyy"))}
                                    />
                                </LocalizationProvider>

                            </Grid>

                            <Grid size={{ xs: 12, md: 12 }} sx={{ mt: -1 }}>

                                <Grid container spacing={3}>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='es'>
                                            <TimePicker
                                                sx={{ width: '100%' }}
                                                label="Hora de inicio"
                                                value={ moment( horaInicio ) }
                                                minTime={ moment( new Date(0, 0, 0, 8, 0) ) }
                                                maxTime={ moment( new Date(0, 0, 0, 15, 0) ) }
                                                onChange={(e) => {
                                                    setHoraInicio(new Date(e?.year() ?? 2025, e?.month() ?? 1, (e?.days() ?? 0) , (e?.hours() ?? 8), (e?.minutes() ?? 0))  );
                                                    setHoraFin(new Date(e?.year() ?? 2025, e?.month() ?? 1, (e?.days() ?? 0) , (e?.hours() ?? 8), (( e?.minutes() ) ?? 0) + ( action === 'Nuevo' ? duracion : audienciaSelected?.duracion ?? 0 ) )  );

                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale='es'>
                                            <TimePicker
                                                sx={{ width: '100%' }}
                                                label="Hora de finalización"
                                                minTime={ moment( horaInicio ) }
                                                value={ moment( horaFin ) }
                                                maxTime={ moment( new Date(0, 0, 0, 16, 0) ) }
                                                //onChange={(e) => { setHoraFin(e?.toDate() ?? new Date()); }}
                                                disabled
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                </Grid>

                            </Grid>

                        </Grid>

                    </Box>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingGuardar || loadingLiberar } onClick={ handleClose }>
                        Cancelar
                    </Button>

                    <Button 
                        variant='contained'
                        onClick={ () => handleGuardar( 5 ) }
                        loading={ loadingGuardar }    
                        disabled={ 
                            secretario === 0 || 
                            ( action === 'Nuevo' && tipoAudiencia === 0 ) || 
                            loadingLiberar || 
                            horaInicio.getTime() === horaFin.getTime() 
                        }             
                    >
                        Guardar
                    </Button>

                    <Button 
                        color='success'
                        variant='contained'
                        onClick={ () => handleGuardar( 6 ) }
                        loading={ loadingLiberar }    
                        disabled={ 
                            secretario === 0 || 
                            ( action === 'Nuevo' && tipoAudiencia === 0 ) || 
                            horaInicio.getTime() === horaFin.getTime() 
                        }             
                    >
                        Liberar
                    </Button>

                </DialogActions>

            </Dialog>

            <Dialog open={openConfirmacionLiberar} onClose={() => { }} >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                       ¿Desea liberar la audiencia seleccionada?
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button
                        color='secondary' 
                        onClick={ () => setOpenConfirmacionLiberar( false ) }
                        disabled={ loadingLiberar }
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant='contained'
                        color='primary'
                        onClick={ handleLiberarAudiencia }
                        loading={ loadingLiberar }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

            <DialogSolicitudes
                open={openSolicitudes}
                setOpen={setOpenSolicitudes}
            />

        </div >
    );
};